import { cn } from '@/lib/utils';
import { useContext } from 'react';

import { ChainlitContext } from '@chainlit/react-client';

import { useTheme } from './ThemeProvider';
import { useAuth } from '@chainlit/react-client';

interface Props {
  className?: string;
}

export const Logo = ({ className }: Props) => {
  const { user } = useAuth();

  const { variant } = useTheme();
  const apiClient = useContext(ChainlitContext);

  const name =
    (user?.metadata as any)?.name ||
    (user?.metadata as any)?.email ||
    user?.identifier ||
    '';

  return (
    // <img
    //   src={apiClient.getLogoEndpoint(variant)}
    //   alt="logo"
    //   className={cn('logo', className)}
    // />
    <div className="flex flex-col gap-2 mb-2 items-center text-center">
      <h1 className="text-2xl font-semibold text-gray-800 dark:text-white">
      {`Hi${name ? ` ${name}` : ''}, how can I help you?`}
      </h1>
    </div>
  );
};
